import styled, { css } from 'styled-components';
import { rem, em } from 'polished';
import { Heading } from 'elements';
import { media, Flex, FlexItem, Main } from 'core/layout';
import { colors } from 'core/theme';

export const StyledContent = styled.article`
  margin-top: 2.5em;
  margin-bottom: 2.5em;

  ${({width}) => width && css`
    width: ${width * 100}%;
  `};

  p {
    color: ${colors.text};
  }

  h1:first-child {
    margin-bottom: 1em;
  }

  h3:first-child {
    margin-bottom: 1em;
  }

  ${media.tablet`
    font-size: ${20/24}rem;
    width: 100%;
  `};

  ${media.tabletSmall`
    h3:first-child,
    h3:first-child + p {
      display: inline-block !important;
      margin: 0 !important;
    }

    h3:first-child + p {
      margin-left: 1em !important;
    }
  `};

  @media print {
    page-break-before: always;
  }
`;

export const StyledTop = styled.article`
  margin-top: ${rem(40)};
  margin-bottom: ${rem(28)};

  h3 {
    margin-bottom: 0 !important;
  }

  a {
    display: inline-block;
    font-size: 1em;

    &:after {
      display: none;
    }
  }

  @media print {
    & > div {
      display: flex !important;
    }
  }
`;

export const Small = styled.small`
  color: ${colors.lightText};
  padding-top:${rem(4)};
  display:block;
`;


export const InputContainer = Flex.extend`
  margin: 0 0 ${em(32)};

  & > div {
    padding-top: 0;
    padding-left: 0;
  }

  ${media.tablet`
    margin: 0 0 ${em(8)};

    & > div {
      flex: 0 0 100%;
    }
  `};
`;

export const CardItem = FlexItem.extend`
  ${media.tabletSmall`
    &:not(:first-child) {
      margin-top: 1em;
    }
  `};
`;

export const MapsGroup = Flex.extend`
    & > div:first-child {
      flex: 0 0 auto;
    }

    ${media.tabletSmall`
      flex-direction: column;

      & > * {
        width: 100%;

        &:not(:first-child) {
          height: 400px;

          & > * {
            height: 100%;
          }
        }
      }
  `};

  ${media.mobile`
      & > * {
        width: 100%;
      }
  `};
`;

export const LinkItem = FlexItem.extend`
  max-width: 50%;

  ${media.tabletSmall`
      max-width: none;

      &:not(:last-child) {
        margin-bottom: 1em;
      }
  `};
`;

export const StyledTable = styled.div`
  h3 {
    margin-bottom: 0 !important;
  }

  h3 + p,
  p {
    margin-top: 0.25em !important;
    margin-bottom: 0 !important;
  }
`;

export const StyledMap = styled.div`
  width: 470px;
  height: 100%;

  & > * {
    width: 100%;
    height: 100%;
  }

  ${media.tablet`
      width: 100%;
  `};

  @media print {
    page-break-inside: avoid;
  }
`;

export const MainHalf = Main.extend`
  flex: 0 0 50%;
  width: 50%;
`;

export const FormGroup = FlexItem.extend`
  flex: 0 1 50%;

  ${media.tablet`
      flex: unset;
      width: 100%;
  `};

  @media print {
    display: none;
  }
`;

export const HideWhenPrint = styled.div`
  @media print {
    display: none;
  }
`;



// WEBPACK FOOTER //
// ./src/pages/Kontakti/styled.js